/**
 * Helpers desacoplados para escopos de cálculo de custo no dashboard PMO.
 * Mantém a montagem de chaves e normalização de issue keys fora do componente.
 */

import { PeriodReportScopeApi } from './pmoReportScope';

export type CostScopeMode = 'visible' | 'full';

/** Página visível: batches menores para preencher colunas rápido. */
export const VISIBLE_COST_BATCH_SIZE = 20;
export const VISIBLE_COST_BATCH_TIMEOUT_MS = 25000;
export const VISIBLE_COST_MAX_SINGLE_RETRIES = 1;
/** Single-request da página: folga maior que o padrão antigo (18s). */
export const VISIBLE_COST_SINGLE_TIMEOUT_MS = 25000;

/** KPIs de HH no período (worklogs + subtarefas): lotes menores e timeout maior (Jira). */
export const FULL_WORKLOG_PERIOD_BATCH_SIZE = 15;
export const FULL_WORKLOG_PERIOD_BATCH_TIMEOUT_MS = 300000;
export const FULL_WORKLOG_PERIOD_MAX_SINGLE_RETRIES = 1;
export const FULL_WORKLOG_PERIOD_EXPORT_TIMEOUT_MS = 300000;

export const normalizeIssueKeysForCost = (
  keys: Array<string | null | undefined>,
): string[] => (
  keys
    .map((key) => String(key || '').trim().toUpperCase())
    .filter(Boolean)
);

export const buildVisibleCostScopeKey = (params: {
  jql: string;
  startAt: number;
  pageSize: number;
  issueKeys: string[];
}): string => (
  JSON.stringify({
    mode: 'visible' as CostScopeMode,
    jql: params.jql,
    startAt: params.startAt,
    pageSize: params.pageSize,
    keys: normalizeIssueKeysForCost(params.issueKeys),
  })
);

export const buildFullCostScopeKey = (params: {
  jql: string;
  issueKeys: string[];
  /** Hash dos filtros PMO ativos — garante recálculo ao mudar carteira/período. */
  filterScope?: string;
  worklogStartDate?: string | null;
  worklogEndDate?: string | null;
  reportScope?: PeriodReportScopeApi;
  /** Escopo export: backend descobre issues via JQL Compras-e (sem chaves fixas). */
  exportJqlDiscovery?: boolean;
}): string => (
  JSON.stringify({
    mode: 'full' as CostScopeMode,
    jql: params.jql,
    filterScope: params.filterScope || '',
    worklogStartDate: params.worklogStartDate || null,
    worklogEndDate: params.worklogEndDate || null,
    reportScope: params.reportScope || null,
    exportJqlDiscovery: Boolean(params.exportJqlDiscovery),
    keys: params.exportJqlDiscovery ? [] : normalizeIssueKeysForCost(params.issueKeys),
  })
);

/** Fase 1/3a: sem metodologia de período e sem recorte De/Até — não satura o Jira do export. */
export const TABLE_COST_PIPELINE_DEFAULTS = {
  reportScope: null as PeriodReportScopeApi,
  worklogStartDate: null as string | null,
  worklogEndDate: null as string | null,
};

/** Fase 3b (export): KPIs de período não redecoram colunas R$ da tabela. */
export const PERIOD_EXPORT_PIPELINE_DEFAULTS = {
  decorateTable: false as const,
};
